import type { SocketType } from "../../types";

/**
 * Map a stateful-table column type to the matching SocketType.
 *
 * Shared by the read-frame filter inputs, the read-frame per-column outputs,
 * the lookup-row outputs and `use_data_mapping`, so one column ends up with the
 * same typed socket everywhere — previously copies that each had a comment
 * asking the others to be kept in sync.
 *
 * The schema snapshot in step config tracks the table's column types, so socket
 * generation stays synchronous (no DB read).
 */
export function statefulTableColumnTypeToSocketType(
  columnType: string,
): SocketType {
  switch (columnType) {
    case "integer":
    case "float":
      return "number" as SocketType;
    case "boolean":
      return "boolean" as SocketType;
    case "date":
      // Dates are persisted as ISO strings on read; downstream consumers see a
      // string, not a Date object.
      return "string" as SocketType;
    case "string":
    default:
      return "string" as SocketType;
  }
}
